import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions, mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/panier.svg';

var CustomProductAddToCartModal = function CustomProductAddToCartModal() {
  return import(
  /* webpackMode: "eager" */
  '~/components/molecules/Product/Modal/CustomProductAddToCartModal.vue');
};

export default {
  name: 'TheCartSection',
  components: {
    CustomProductAddToCartModal: CustomProductAddToCartModal
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    products: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      showModal: false
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  methods: _objectSpread({}, mapActions({
    addCart: 'cart/add'
  }), {
    openLayer: function openLayer() {
      this.$root.$emit('open-layer', {
        state: true,
        name: 'LayerAddToCart',
        products: this.products
      });
      return false;
    },
    addToCart: function () {
      var _addToCart = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.openLayer();

                if (!this.products[0]) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return this.addCart({
                  reference: this.products[0].reference,
                  referenceEncoded: btoa(this.products[0].reference),
                  quantity: 1
                });

              case 5:
                if (!this.products[1]) {
                  _context.next = 8;
                  break;
                }

                _context.next = 8;
                return this.addCart({
                  reference: this.products[1].reference,
                  referenceEncoded: btoa(this.products[1].reference),
                  quantity: 1
                });

              case 8:
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function addToCart() {
        return _addToCart.apply(this, arguments);
      }

      return addToCart;
    }(),
    closeAction: function closeAction() {
      this.showModal = false;
    }
  })
};